import { tokens } from '@sail/ui';
import { helmTokens } from './helmTokens';
export const lightSailColor = {
    icon: {
        $default: tokens.color.neutral[900],
        emphasized: tokens.color.neutral[900]
    },
    text: {
        $default: tokens.color.neutral[700],
        emphasized: tokens.color.neutral[900],
        subdued: tokens.color.neutral[500],
        action: {
            primary: {
                $default: helmTokens.color.accentColor,
                hovered: tokens.color.neutral[900]
            },
            secondary: {
                $default: tokens.color.neutral[900],
                hovered: 'rgba(10, 37, 64, 0.6)'
            }
        },
        onAction: {
            primary: {
                pressed: tokens.color.brand[0]
            },
            // secondary is our "Link" style for CtaButton
            // this could be a problem if we have a secondary action
            // tokens are used elsewhere but good for now
            secondary: {
                $default: helmTokens.color.accentColor,
                hovered: tokens.color.neutral[900],
                pressed: tokens.color.neutral[800]
            }
        },
        form: {
            $default: tokens.color.neutral[800],
            hovered: tokens.color.neutral[900],
            placeholder: tokens.color.neutral[500]
        }
    },
    background: {
        surface: tokens.color.neutral[100],
        offset: tokens.color.neutral[0],
        action: {
            primary: {
                $default: helmTokens.color.accentColor,
                hovered: tokens.color.neutral[900],
                pressed: tokens.color.neutral[800]
            },
            secondary: {
                $default: 'transparent',
                hovered: 'transparent',
                pressed: 'transparent'
            }
        },
        form: {
            $default: tokens.color.neutral[100],
            accent: tokens.color.brand[600]
        }
    },
    border: {
        action: {
            primary: {
                $default: helmTokens.color.accentColor,
                hovered: tokens.color.neutral[900],
                pressed: 'transparent'
            }
        },
        form: 'transparent'
    }
};
export const color = {
    neutral: {
        0: '#ffffff',
        100: '#f6f9fc',
        200: '#e7ecf1',
        300: '#c4ccd8',
        400: '#abb5c5',
        500: '#727f96',
        600: '#4f5b76',
        700: '#3f4b66',
        800: '#2e3a55',
        900: '#0a2540'
    },
    brand: {
        600: '#635bff',
        800: '#274869',
        900: '#0c2e4e'
    },
    ...lightSailColor
};

//# sourceMappingURL=color.js.map